import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LoginMenuComponent } from './components/login-menu/login-menu.component';
import { SafeUrlPipe } from './pipes/pipe/safe-url.pipe';
import { RouterModule } from '@angular/router';
import { faUser, faCoffee, faKey, faLockOpen, faUserLock, faLock, faGlobe, faNewspaper, faDumbbell, faHeartPulse, faPersonRunning } from '@fortawesome/free-solid-svg-icons';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { EditorModule } from '@tinymce/tinymce-angular';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { CdkTableModule } from '@angular/cdk/table';
import { MatTableModule } from '@angular/material/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatChipsModule } from '@angular/material/chips';

@NgModule({
  declarations: [
    LoginMenuComponent,
    SafeUrlPipe
  ],
  imports: [
    CommonModule,
    FontAwesomeModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    EditorModule,
    MatDialogModule,
    MatButtonModule,
    CdkTableModule,
    MatTableModule,
    MatProgressSpinnerModule,
    MatSortModule,
    MatPaginatorModule,
    MatChipsModule,
  ],
  exports: [
    CommonModule,
    FontAwesomeModule,
    RouterModule,
    LoginMenuComponent,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    EditorModule,
    MatDialogModule,
    MatButtonModule,
    CdkTableModule,
    MatTableModule,
    MatProgressSpinnerModule,
    MatSortModule,
    MatPaginatorModule,
    MatChipsModule,
    SafeUrlPipe
  ]
})
export class SharedModule {
  constructor(library: FaIconLibrary) {
    library.addIcons(faCoffee, faLockOpen, faUserLock, faUser, faLock, faKey, faGlobe, faNewspaper,faDumbbell, faHeartPulse, faPersonRunning ); // Adicione os ícones que vai usar
  }
}